import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import fundAccount from "@/views/Home/assets/fundAccount/fundAccount.vue"
import spotAccount from "@/views/Home/assets/spotAccount/spotAccount.vue";
import futuresAccount from "@/views/Home/assets/futuresAccount/futuresAccount.vue"
import optionsAccount from "@/views/Home/assets/optionsAccount/optionsAccount.vue"
import investmentAccount from "@/views/Home/assets/investmentAccount/investmentAccount.vue"
import capitalFlow from "@/views/Home/assets/capitalFlow/capitalFlow.vue"
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import FlashSwap from "@/components/FlashSwap/FlashSwap.vue";

import upTrigget from "@/components/topUp/topUp.vue"
import withdrawTrgget from "@/components/withdraw/withdraw.vue"

import user from "@/common/api/user";
import {mapGetters} from "vuex";

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';
// 引入swiper模块
import {Navigation} from 'swiper/modules';


import VChart from 'vue-echarts';
import * as echarts from 'echarts/core';
import {
    PieChart
} from 'echarts/charts';
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';
import NotDate from "@/components/notdate/notdate.vue";
import {useRoute} from "vue-router";

echarts.use([PieChart, TooltipComponent, LegendComponent, CanvasRenderer, TitleComponent]);

let currency;

export default {
    components: {
        NotDate,
        Footer,
        PageNav,
        fundAccount,
        spotAccount,
        futuresAccount,
        optionsAccount,
        investmentAccount,
        VChart,
        capitalFlow,
        fundsTransfe,
        FlashSwap,
        Swiper,
        SwiperSlide,
        upTrigget,
        withdrawTrgget
    },
    data() {
        return {
            modules: [Navigation],
            upShow: false,
            withdrawShow: false,
            flashSwapShow: false,
            menuList: [],
            transfeShow: false,
            menuActive: 0,
            visual: false,
            balance: [],
            total: 0,
            trade: "",
            contract: "",
            future: "",
            finance: "",
            list: [],
            chartOption: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: 40,
                    top: "center",
                    itemGap: 20,
                    textStyle: {
                        color: '#565656',
                        fontSize: 14
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        label: {
                            show: false
                        },
                        center: ['15%', '50%'],
                        radius: '75%',
                        data: [
                            // { value: 1048, name: '资金' },
                            // { value: 735, name: '现货' },
                            // { value: 580, name: '合约' },
                            // { value: 484, name: '期权' },
                            // { value: 300, name: '理财' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.updateMenuText();
        let route = useRoute();
        let params = route.query;
        if(params.menu){
            this.menuActive = parseInt(params.menu);
        }
        // 延迟加载数据，确保DOM完全渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.getBalance();
            }, 100);
        });
    },
    watch: {
        // 监听语言变化
        '$i18n.locale'() {
            this.updateMenuText();
            // 重新创建图表以更新图表中的文字
            if (this.list && this.list.length > 0) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.createCircleChart();
                    }, 50);
                });
            }
        }
    },
    computed: {
        ...mapGetters(['symbol', 'symbol_rate', 'userTheme'])
    },
    methods: {
        // 更新菜单文本
        updateMenuText() {
            if (!this.$t) return;
            
            this.menuList = [
                {
                    id: "1",
                    text: this.$t('assets.overview')
                }, {
                    id: "2",
                    text: this.$t('assets.fund_account')
                }, {
                    id: "3",
                    text: this.$t('assets.spot_account')
                }, {
                    id: "4",
                    text: this.$t('assets.futures_account')
                }, {
                    id: "5",
                    text: this.$t('assets.options_account')
                }, {
                    id: "6",
                    text: this.$t('assets.finance_account')
                }, {
                    id: "7",
                    text: this.$t('assets.fund_flow')
                }
            ];
        },
        
        createCircleChart() {
            // 确保DOM元素存在且已渲染
            this.$nextTick(() => {
                const data = [
                    {value: parseFloat(this.balance), name: this.$t('assets.fund_account')},
                    {value: parseFloat(this.trade), name: this.$t('assets.spot_account')},
                    {value: parseFloat(this.contract), name: this.$t('assets.futures_account')},
                    {value: parseFloat(this.future), name: this.$t('assets.options_account')},
                    {value: parseFloat(this.finance), name: this.$t('assets.finance_account')}
                ];
                this.chartOption['series'][0]['data'] = data;
            });
        },
        async getBalance() {
            let res = await user.getBalance();
            try {
                if (res.code === 200) {
                    let balance = 0;
                    let total = 0;
                    let trade = 0;
                    let contract = 0;
                    let future = 0;
                    let finance = 0;
                    res.data.balance.map((item) => {
                        if (item.symbol === 'USDT') {
                            total += parseFloat(item.balance) + parseFloat(item.contract_balance) +
                                parseFloat(item.finance_balance) + parseFloat(item.future_balance) +
                                parseFloat(item.trade_balance);
                            balance += parseFloat(item.balance);
                            trade += parseFloat(item.trade_balance);
                            contract += parseFloat(item.contract_balance);
                            future += parseFloat(item.future_balance);
                            finance += parseFloat(item.finance_balance);

                        } else {
                            let new_price = parseFloat(item.new_price != null ? item.new_price : 0);
                            total += (parseFloat(item.balance) + parseFloat(item.contract_balance) +
                                parseFloat(item.finance_balance) + parseFloat(item
                                    .future_balance) +
                                parseFloat(item.trade_balance)) * new_price;

                            balance += parseFloat(item.balance) * new_price;
                            trade += parseFloat(item.trade_balance) * new_price;
                            contract += parseFloat(item.contract_balance) * new_price;
                            future += parseFloat(item.future_balance) * new_price;
                            finance += parseFloat(item.finance_balance) * new_price;

                        }
                    });

                    this.total = total;
                    this.balance = balance;
                    this.trade = trade;
                    this.contract = contract;
                    this.future = future;
                    this.finance = finance;

                    this.list = res.data.balance;
                    currency = res.data.balance;
                    this.createCircleChart();
                }
            } catch (e) {
                console.log(e);
            }
        },
        
        // 刷新资产数据
        async refreshAssets() {
            await this.getBalance();
        }
    }
}